$(document).ready(function(){	
	setupScroll("#photos-box", {interval: 5000, force: true});
	setupScrollItem(".item-images-scroll", {interval: 3000,force: true});
	Fancybox.bind("[data-fancybox]", {
		// Fancybox v4 options
		on: {
			reveal: function() {
				$('object, embed, iframe').css("margin-left", "-10000px");
			},
			close: function() {
				$('object, embed, iframe').css("margin-left", "auto");
			}
		}
	});
	$('#bid_price').on("change", function() {
		this.value=parseFloat(this.value).toFixed(2);
	})
	
	$('#tickets').on("change", function() {
		window.$('#bid_price').attr('value',(parseFloat($('#bid_price').attr('data-price'))*this.value).toFixed(2))
	})

	$('.toggle-file-input').on('click', function(event) {
		event.preventDefault();

	const targetId = $(this).data('target');
	const previewId = $(this).data('preview');
	if (previewId) {
		$('#' + previewId).addClass('is-hidden');
	}

	if (targetId) {
		const $target = $('#' + targetId);
		$target.removeClass('is-hidden');
		const $fileInput = $target.find('input[type="file"]').first();
		if ($fileInput.length) {
			$fileInput.trigger('focus');
		}
	}
	});

	$('.toggle-file-cancel').on('click', function(event) {
		event.preventDefault();

	const targetId = $(this).data('target');
	const previewId = $(this).data('preview');

	if (targetId) {
		const $target = $('#' + targetId);
		const $fileInput = $target.find('input[type="file"]').first();
		if ($fileInput.length) {
			$fileInput.val('');
		}
		$target.addClass('is-hidden');
	}

	if (previewId) {
		$('#' + previewId).removeClass('is-hidden');
	}
	});

	document.querySelectorAll('.donut-chart').forEach(el => {
		const percent = el.getAttribute('data-percentage');
		el.style.setProperty('--percentage', percent);
	  });
	
})

window.setupScroll = function (target, options){
	try {
	var $target = $(target);
	var nodes = $target.children().length;
	$target.wrap("<div id='scroll-wrap'></div>");
	$("#scroll-wrap").css({overflow: "hidden", position: "relative", height: $target.height() + "px"});
	$target.children().css({float: "left", width: $target.width(), display: "block"});
	$target.width($target.width() * nodes);
	
	$target.localScroll({target: "#scroll-wrap", duration: 250, axis: "x", easing: "easeInOutQuad"});
	
	if (nodes > 1) {
	
		let serialOptions = {
			items: target + " > *", 
			duration: 250, 
			axis: 'xy', 
			easing: "easeInOutQuad"
		};

		$.extend(serialOptions, options);
		$('#scroll-wrap').serialScroll(serialOptions);
	}
	
	} catch(e) {
		console.warn(e.message);
	}
}

window.setupScrollItem = function (target, options){
	try {
		$(target).each(function(index) {
			var $target = $(this);
			var nodes = $target.children().length;
			
			if (nodes <= 1) {
				return; // No need to scroll if there's only one item
			}
			
			$target.wrap("<div class='scroll-wrap'></div>");
			var $wrap = $target.parent();
			$wrap.css({overflow: "hidden", position: "relative", height: $target.height() + "px"});
			$target.children().css({float: "left", width: $target.width(), display: "block"});
			$target.width($target.width() * nodes);
			
			var serialOptions = {
				items: $target.children(),
				duration: 250,
				axis: "x",
				easing: "easeInOutQuad",
				force: true,
				cycle: true
			};

			$.extend(serialOptions, options || {});
			
			$wrap.serialScroll(serialOptions);

			if (options && options.interval) {
				var scrollInterval = setInterval(function() {
					$wrap.trigger("next.serialScroll");
				}, options.interval);
				
				$wrap.trigger("start.serialScroll");
			}
		});
	} 
	catch(e) {
		console.warn(e.message);
	}

}
